import { toast } from 'react-toastify';
import { getErrorMessage } from 'utils/utilities';

// Centralized error handling for UserDetails (Rule 9 — no direct toast.error in the form).
export const handleError = (error) => toast.error(getErrorMessage(error));
